import {
  BedIcon,
  StarHalfIcon,
  StarIcon,
  SparkleIcon,
  CallBellIcon,
  CoffeeIcon,
  SuitcaseRollingIcon,
} from "@phosphor-icons/react";
import type { ChangeEvent } from "react";

import { Checkbox } from "@/components/Checkbox/Checkbox";
import { Divider } from "@/components/Divider/Divider";
import { BoardBasisName } from "@/features/hotels/components/hotel/BoardBasisName";
import { BOARD_BASIS_OPTIONS } from "@/features/hotels/utils/constants";

const BOARD_BASIS_ICONS: Record<string, React.JSX.Element> = {
  HB: <StarHalfIcon size={20} className="fill-secondary" />,
  FB: <StarIcon size={20} className="fill-secondary" />,
  AI: <SparkleIcon size={20} className="fill-secondary" />,
  RO: <BedIcon size={20} className="fill-secondary" />,
  SC: <CallBellIcon size={20} className="fill-secondary" />,
  BB: <CoffeeIcon size={20} className="fill-secondary" />,
  RD: <SuitcaseRollingIcon size={20} className="fill-secondary" />,
};

type Props = {
  selected?: string[];
  userManuallySelectedAll: boolean;
  onChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    option: string,
  ) => void;
};

export const BoardBasisFilter = ({
  selected = [],
  userManuallySelectedAll,
  onChange,
}: Props) => {
  const areAllClassesSelected = selected.length === BOARD_BASIS_OPTIONS.length;

  return (
    <ul>
      {BOARD_BASIS_OPTIONS.map((option) => (
        <li key={option}>
          <label className="flex w-full items-center justify-between py-2">
            <div className="flex items-center gap-4">
              {BOARD_BASIS_ICONS[option]}
              <span className="font-medium text-text-primary">
                <BoardBasisName boardBasis={option} />
              </span>
            </div>
            <Checkbox
              checked={
                selected?.includes(option) &&
                (userManuallySelectedAll || !areAllClassesSelected)
              }
              onChange={(e) => onChange(e, e.target.checked, option)}
              density="compact"
            />
          </label>
          <Divider />
        </li>
      ))}
    </ul>
  );
};
